export const SCREENS = {
    CMO_OVERVIEW: "cmo-overview",
    BRAND_ANALYSIS: "brand-analysis",
    BRAND_PROFILE: "brand-profile",
    MARKETING_PLAN: "marketing-plan",
    AD_CONCEPTS: "ad-concepts",
    GENERATE_ADS: "generate-ads",
    EDITOR: "editor",
    CREATIVES: "creatives",
    PERFORMANCE: "performance"
}

export const analysisSteps = [
    "Analyzing your website",
    "Understanding your product",
    "Defining your audience",
    "Positioning your message",
]

export const productStageOptions = [
    { id: "just-launched", label: "Just launched", description: "New product, no sales yet" },
    { id: "some-sales", label: "Some sales already", description: "Getting traction, learning what works" },
    { id: "scaling", label: "Scaling with ads", description: "Ready to invest more in growth" },
]

export const goalOptions = [
    { id: "first-customers", label: "Get first customers", icon: "Users" },
    { id: "generate-leads", label: "Generate leads", icon: "Target" },
    { id: "increase-sales", label: "Increase sales", icon: "TrendingUp" },
    { id: "grow-audience", label: "Grow audience", icon: "Users" },
]

export const budgetOptions = [
    { id: "organic", label: "$500", description: "Organic only" },
    { id: "testing", label: "$2500", description: "Testing ads" },
    { id: "scaling", label: "$7500", description: "Scaling campaigns" },
]

export const buckets = [
    { id: "all", name: "All Buckets" },
    { id: "ugc-hooks", name: "UGC Hooks" },
    { id: "winning-ads", name: "Winning Ads" },
    { id: "facebook-tests", name: "Facebook Tests" },
    { id: "saas-ads", name: "SaaS Ads" },
]

export const savedCards = [
    {
        id: 1,
        author: "Nothing Held Back",
        image: "/gmail-promotions-fire-laptop.jpg",
        title: "Here's every insight & trend I'm seeing right now to avoid the Gmail Promo Tab",
        platform: "facebook",
        isVideo: false,
    },
    {
        id: 2,
        author: "Education Today",
        image: "/mount-fuji-japan-flag-scholarships.jpg",
        title: "SCHOLARSHIPS IN JAPAN",
        platform: "instagram",
        isVideo: false,
    },
    {
        id: 3,
        author: "UEFA Champions League",
        image: "/uefa-champions-league-soccer-match.jpg",
        title: "2024 Ballon d'Or winner: Rodri",
        platform: "tiktok",
        isVideo: true,
    },
    {
        id: 4,
        author: "Meta for Business",
        image: "/drive-more-traffic-business-restaurant-food.jpg",
        title: "Your last post could be your first ad",
        platform: "facebook",
        isVideo: false,
    },
    {
        id: 5,
        author: "Canva",
        image: "/designer-workspace-laptop-creative-tools.jpg",
        title: "Create stunning designs effortlessly",
        platform: "instagram",
        isVideo: false,
    },
    {
        id: 6,
        author: "Nike",
        image: "/nike-running-shoes-athlete-action.jpg",
        title: "Push your limits. Break your records.",
        platform: "instagram",
        isVideo: false,
    },
    {
        id: 7,
        author: "Shopify",
        image: "/modern-creative-workspace-desk-setup-design-studio.jpg",
        title: "Turn your passion into profit",
        platform: "facebook",
        isVideo: false,
    },
    {
        id: 8,
        author: "HubSpot",
        image: "/orange-social-media.jpg",
        title: "The ultimate guide to social media marketing",
        platform: "instagram",
        isVideo: false,
    },
    {
        id: 9,
        author: "Notion",
        image: "/woman-working-at-desk-with-colorful-materials.jpg",
        title: "Organize your life in one place",
        platform: "tiktok",
        isVideo: true,
    },
    {
        id: 10,
        author: "Figma",
        image: "/modern-graphic-design-workspace-with-colorful-crea.jpg",
        title: "Design together, ship faster",
        platform: "instagram",
        isVideo: false,
    },
    {
        id: 11,
        author: "Stripe",
        image: "/yellow-marketing-guide.jpg",
        title: "Payments infrastructure for the internet",
        platform: "facebook",
        isVideo: false,
    },
    {
        id: 12,
        author: "Mailchimp",
        image: "/video-content-marketing.jpg",
        title: "Email marketing that actually works",
        platform: "tiktok",
        isVideo: true,
    },
]

export const adConceptsData = [
    {
        id: "1",
        hook: "I used to lose every ad I saved… until I did this",
        concept: "Founder talking to camera about losing saved ads → quick cut to a clean, organized creative vault",
        cta: "See how it works",
        type: "ugc",
        selected: false,
        whyThisIdea: "People see themselves in this immediately → so they keep watching",
        expectedOutcome: "People stop scrolling and watch",
        status: "generated",
    },
    {
        id: "2",
        hook: "I didn't expect this to actually work… but it saved me 3 hours",
        concept: "User casually reacting to results → quick cuts of turning saved content into usable ads",
        cta: "Try it yourself",
        type: "image",
        selected: false,
        whyThisIdea: "The skepticism feels honest → so the result feels real",
        expectedOutcome: "People get curious and click",
        status: "In_progress",
    },
    {
        id: "3",
        hook: "I stopped creating ads from scratch… now I launch 5x faster",
        concept: "Messy workflow with scattered tabs → fast switch to clean, organized creative vault",
        cta: "Start building yours",
        type: "video",
        selected: false,
        whyThisIdea: "They already feel this pain → so the fix clicks instantly",
        expectedOutcome: "People want to try this",
        status: "not_started",
    },
    {
        id: "4",
        hook: "Here's how I never lose a good ad again",
        concept: "Casual screen recording walkthrough showing how to save, tag, and find ads in seconds — no fluff",
        cta: "Follow for more tips",
        type: "organic-video",
        selected: false,
        whyThisIdea: "It feels like a friend sharing a secret → not a brand selling something",
        expectedOutcome: "People follow for more",
        status: "not_started",
    },
    {
        id: "5",
        hook: "3 mistakes I made with ad research (and what actually works)",
        concept: "Carousel with each mistake + fix → ending with your product as the final recommendation",
        cta: "Save this for later",
        type: "organic-post",
        selected: false,
        whyThisIdea: "Mistakes feel relatable → so they stick around for the fix",
        expectedOutcome: "People save this for later",
        status: "not_started",
    },
    {
        id: "6",
        hook: "Watch me find 10 winning ad ideas in under 2 minutes",
        concept: "Fast-paced screen recording showing search, save, and organize flow — real time, no edits",
        cta: "Start building yours",
        type: "demo",
        selected: false,
        whyThisIdea: "Speed is impossible to fake → so they trust what they see",
        expectedOutcome: "People want to try this themselves",
        status: "not_started",
    },
]

export const generatedVideos = [
    { id: 1, brand: "Viral Marketing Stars®", avatar: "Desire", thumbnail: "/woman-with-edamame-snack-bags-smiling.jpg" },
    { id: 2, brand: "Viral Marketing Stars®", avatar: "Maya", thumbnail: "/woman-eating-edamame-snack-outdoors-green-backgrou.jpg" },
    { id: 3, brand: "Viral Marketing Stars®", avatar: "Maya", thumbnail: "/sophie-outdoor-casual-green.jpg" },
    { id: 4, brand: "Viral Marketing Stars®", avatar: "Desire", thumbnail: "/woman-running-with-edamame-snack.jpg" },
]

export const campaigns = [
    {
        name: "Ad Inspiration Awareness",
        audience: "Digital Marketers",
        platform: "Instagram / TikTok",
        adsToCreate: 2,
        organicToCreate: 1,
        icon: "Target",
        whatItDoes: "Introduces the problem of losing ad inspiration in social feeds.",
        whyItWorks: "This pain point is easy for marketers to relate to and immediately grabs attention.",
        whyNow: "You are still testing messaging, so we start with a simple problem-solution campaign.",
    },
    {
        name: "Time-Saving Benefits",
        audience: "Agency Owners",
        platform: "Facebook / LinkedIn",
        adsToCreate: 1,
        organicToCreate: 1,
        icon: "TrendingUp",
        whatItDoes: "Positions your product as a time-saving tool for busy agency owners.",
        whyItWorks: "Agency owners value efficiency above all and respond well to productivity messaging.",
        whyNow: "After testing awareness, we expand to benefit-focused messaging for high-value prospects.",
    },
]